module.exports = __webpack_public_path__ + "img/solution4.6adcb192.png";